(function () {
  'use strict';

  var quantityMap = {
    '5-100': ['5-99', '5–99 pcs (Low MOQ)'],
    '100-500': ['100-499', '100–499 pcs'],
    '500-1000': ['500-999', '500–999 pcs'],
    '500+': ['500+', '500+ pcs'],
    '1000+': ['1000+', '1,000+ pcs']
  };

  function normaliseQuantitySelect(select) {
    if (!select || select.dataset.florixNormalised === 'true') return;

    Array.from(select.options).forEach(function (option) {
      var replacement = quantityMap[option.value];
      if (!replacement) return;
      option.value = replacement[0];
      option.textContent = replacement[1];
    });

    var seen = Object.create(null);
    Array.from(select.options).forEach(function (option) {
      if (!option.value) return;
      if (seen[option.value]) {
        option.remove();
      } else {
        seen[option.value] = true;
      }
    });

    select.dataset.florixNormalised = 'true';
  }

  function initialise() {
    document.querySelectorAll('select[id^="qf-quantity-"]').forEach(normaliseQuantitySelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
